import {Box, Button, Collapse, Stack, Typography} from '@mui/material';
import {FontIcon} from '@resurs-internal/mui';
import React, {useState} from 'react';
import {useTranslate} from '../../hooks';

const HOW_TO_SIGN_PANEL_ID = 'how-to-sign-panel';

export const HowToSignToggle: React.FC = () => {
  const t = useTranslate();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        variant={'text'}
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
        aria-controls={HOW_TO_SIGN_PANEL_ID}
        sx={{
          justifyContent: 'space-between',
          textTransform: 'none',
          color: 'text.primary',
        }}
        endIcon={<FontIcon icon={isOpen ? 'chevron-down' : 'chevron-right'} />}>
        {t('signature.bankid.howToSign')}
      </Button>
      <Collapse in={isOpen} unmountOnExit>
        <Stack id={HOW_TO_SIGN_PANEL_ID} spacing={1.5} pb={1}>
          {([1, 2, 3, 4] as const).map((step) => (
            <Stack
              key={step}
              direction={'row'}
              spacing={1}
              alignItems={'flex-start'}>
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  fontSize: '0.75rem',
                }}>
                {step}
              </Box>
              <Typography variant={'body2'}>
                {t(`signature.bankid.howToSign.step${step}`)}
              </Typography>
            </Stack>
          ))}
          <Typography variant={'body2'} color={'text.secondary'}>
            {t('signature.bankid.howToSign.fallback')}
          </Typography>
        </Stack>
      </Collapse>
    </>
  );
};
